import { createGlobalStyle } from 'styled-components';
import { linkStyles } from '../styled/links';
import { HeaderWrapper } from '../header/styles';
import { SideBar } from '../styled/containers';
import { focusStyles } from '../styled/focus';

import 'sanitize.css';

export const GlobalStyle = createGlobalStyle`

    p, h5, h6 {
        margin-top: 0px;
    }

    ol, ul, dl {
        margin-top: 0px;
        margin-bottom: 1rem;
    }

    :where(button, input, select, textarea) {
        font: inherit; /* 2 */
    }

    :where(nav li)::before {
        content: none;
    }

    label {
        display: inline-block;
    }

    fieldset {
        min-width: 0px;
        padding: 0px;
        margin: 0px;
        border: 0px;
    }

    blockquote {
        margin: 0px 0px 1rem;
    }

    legend {
        display: block;
        width: 100%;
        max-width: 100%;
        padding: 0px;
        margin-bottom: 0.5rem;
        font-size: 1.5rem;
        line-height: inherit;
        color: inherit;
        white-space: normal;
    }

    address {
        margin-bottom: 1rem;
        font-style: normal;
        line-height: inherit;
    }

    th {
        text-align: inherit;
    }

    @font-face {
        font-family: 'Barlow';
        font-style: normal;
        font-weight: 400;
        src: url(/fonts/barlow-regular.woff2) format('woff2'),
             url(/fonts/barlow-regular.woff) format('woff');
        font-display: swap;
      }

      @font-face {
        font-family: 'Barlow';
        font-style: normal;
        font-weight: 700;
        src: url(/fonts/barlow-700.woff2) format('woff2'),
             url(/fonts/barlow-700.woff) format('woff');
        font-display: swap;
      }

      @font-face {
        font-family: 'Barlow Condensed';
        font-style: normal;
        font-weight: 700;
        src: url(/fonts/barlow-condensed-700.woff2) format('woff2'),
          url(/fonts/barlow-condensed-700.woff) format('woff');
        font-display: swap;
      }
      
    html {
        font-size: 18px;
    }

    body {
        min-height: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-family: ${({ theme }) => theme.fonts.primary};
        color: ${({ theme }) => theme.palette.standardText};
        font-size: ${({ theme }) => theme.fontsize.base};
        line-height: ${({ theme }) => theme.lineHeights.base};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: ${({ theme }) => theme.fonts.header};
        font-weight: ${({ theme }) => theme.fontWeight.normal};
    }

    h1 {
        ${({ theme }) => theme.headers.h1}
    }

    h2 {
        ${({ theme }) => theme.headers.h2}
    }

    h3 {
        ${({ theme }) => theme.headers.h3}
    }

    h4 {
        ${({ theme }) => theme.headers.h4}
    }

    p {
      margin-bottom: ${({ theme }) => theme.spacing.standard};
    }

    small {
        font-size: ${({ theme }) => theme.fontsize.small};
        line-height: ${({ theme }) => theme.lineHeights.base};
    }

    img {
        max-width: 100%;
    }

    a {
        ${linkStyles};
    }

    button {
        &:focus {
            ${focusStyles}
        }
    }

    li {
        margin-bottom: ${({ theme }) => theme.spacing.standard};
    }

    ol {
        list-style: none;
        padding-left: 0;
    }

    ol li{
        counter-increment: step-counter;
        position: relative;
        padding-left: 2em;
    }

    ol li:before {
        content: counter(step-counter);
        display: block;
        font-size: inherit;
        left: .6em;
        min-width: 1em;
        position: absolute;
        text-align: center;
        top: 0;
    }

    hr{
        border: none;
        border-top: 2px solid ${({ theme }) => theme.palette.disabled};
        clear: both;
        margin-bottom: ${({ theme }) => theme.spacing.standard};
        margin-top: ${({ theme }) => theme.spacing.medium};
    }

    .ReactModal__Body--open {
        overflow: hidden;
        position: fixed;
        width: 100%;
        height: 100%;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
    -moz-appearance: textfield;
    }

    label {
        margin-bottom: ${({ theme }) => theme.spacing.tiny};
    }

    @media print {
        ${HeaderWrapper}, ${SideBar}, nav {
            display: none !important;
        }
        *  {
            color: ${({ theme }) => theme.palette.standardText} !important;
        }

        ._hj-widget-container,
        ._hj_feedback_container  {
            display: none !important;
        }
    }

    // hide the recaptcha badge
    .grecaptcha-badge {
      visibility: hidden;
    }
`;
